import WhyUs from './WhyUs'

export default WhyUs
